import { useRef } from 'react';
import { stylists } from '@/mocks/home';
import { useMotion } from '@/hooks/useEditorialMotion';
import BookButton from '@/pages/home/components/BookButton';

export default function Stylists() {
  const ref = useRef<HTMLElement>(null);
  useMotion(ref);
  return (
    <section ref={ref} id="stylists" className="bg-background-100 py-16 md:py-28">
      <div className="max-w-[1320px] mx-auto px-5 md:px-12 lg:px-16">
        <div data-group className="grid grid-cols-1 lg:grid-cols-12 gap-x-6 gap-y-4 mb-10 md:mb-14 items-end">
          <h2 data-m="title" className="lg:col-span-7 font-heading font-semibold tracking-[-0.02em] leading-[1.05] text-[36px] md:text-[52px] text-foreground-950">The Artists</h2>
          <p data-m="text" data-at="0.18" className="lg:col-span-5 text-[16px] leading-relaxed text-foreground-700">Three stylists, each with their own specialty. Book directly with the one that suits your hair.</p>
        </div>
        <div className="flex sm:grid sm:grid-cols-3 gap-6 overflow-x-auto sm:overflow-visible snap-x snap-mandatory -mx-5 px-5 sm:mx-0 sm:px-0 pb-2 sm:pb-0">
          {stylists.map((s) => (
            <article key={s.name} data-group className="snap-start shrink-0 w-[78%] sm:w-auto">
              <div data-m="portrait" className="w-full aspect-[3/4] overflow-hidden bg-background-50">
                <img data-m="scale" src={s.src} width={900} height={1200} loading="lazy" decoding="async" alt={`${s.name}, ${s.role} at NOVA Hair Studio`} title={`${s.name} — ${s.role}`} className="w-full h-full object-cover object-top" />
              </div>
              <h3 data-m="caption" data-at="0.12" className="mt-5 text-[22px] font-semibold text-foreground-950">{s.name}</h3>
              <p data-m="caption" data-at="0.12" className="mt-1 text-[14px] text-foreground-950">{s.role}</p>
              <p data-m="caption" data-at="0.12" className="mt-1 text-[14px] text-foreground-600">{s.specialty}</p>
              <div data-m="caption" data-at="0.12" className="mt-4"><BookButton variant="text" label={`Book with ${s.first}`} /></div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}